<template>
    <div class="wrapper" @click="$router.go(-1)">
        <van-icon name="arrow-left" class="arrow-left"/>
        <span class="back">返回</span>
    </div>
</template>

<script>
    import { Icon } from 'vant';
    export default {
        components: {
            [Icon.name]: Icon
        }
    }
</script>

<style scoped lang="less">
    .wrapper{
        width: 100%;
        padding-left: 14px;
        margin-top: 10px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .arrow-left{
            font-size: 20px;
        }
        .back{
            margin-left: 8px;
            font-weight:400;
            color:rgba(65,65,65,1);
            font-size: 18px;
        }
    }
</style>